// styles
import styled from 'styled-components';
import {
  useSoFormStepsApi,
  useSoFormStepsState,
} from 'refactored/features/soForm/SoForm.context';
import { getAvailableTimeRanges } from './economyUtils';
import SoRangePicker from './SoRangePicker';
import moment from 'moment-timezone';

const SoEconomyRangePicker = ({ candidate, className, isPickup }) => {
  const stepsState = useSoFormStepsState();
  const stepsApi = useSoFormStepsApi();
  const shipment = candidate.formData.quotePayload.shipments[0];

  const windowTimeInHours = stepsState.price.use6hoursWindow ? 6 : 8;

  const dayOfYear = moment(shipment.pickup_time_from).dayOfYear();
  const minTime = moment(candidate.formData.minTime)
    .dayOfYear(dayOfYear)
    .hours(0)
    .minutes(0)
    .toJSON();

  const availableTimeRangesPickup = getAvailableTimeRanges({
    minTime,
    windowTimeInHours,
    itemIncrementInMinutes: 30,
  });

  const availableTimeRangesDropoff = getAvailableTimeRanges({
    minTime: shipment.pickup_time_from,
    windowTimeInHours,
    itemIncrementInMinutes: 30,
  });

  //   pickup

  const setPickupRange = (range) => {
    const newTimes = {
      pickup_time_from: range.from,
      pickup_time_to: range.to,
      dropoff_time_from: range.from,
      dropoff_time_to: range.to,
    };
    stepsApi.setEconomyRange({ newTimes, candidate });
  };

  const setDropoffRange = (range) => {
    const newTimes = {
      dropoff_time_from: range.from,
      dropoff_time_to: range.to,
    };
    stepsApi.setEconomyRange({ newTimes, candidate });
  };

  //   values for this range picker

  const timeFrom = isPickup
    ? shipment.pickup_time_from
    : shipment.dropoff_time_from;

  const timeTo = isPickup ? shipment.pickup_time_to : shipment.dropoff_time_to;

  const availableTimes = isPickup
    ? availableTimeRangesPickup
    : availableTimeRangesDropoff;

  const selectFunction = isPickup ? setPickupRange : setDropoffRange;

  return (
    <SoRangePicker
      timeFrom={timeFrom}
      timeTo={timeTo}
      availableTimes={availableTimes}
      selectFunction={selectFunction}
    />
  );
};

export default styled(SoEconomyRangePicker)`
  /* display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 12px 16px 16px;
  gap: 16px;
  width: 600px;
  border-radius: 4px 4px 0px 0px; */
`;
